"use strict";

require("core-js/modules/es.array.reduce.js");

var _assign = function __assign() {
  return (_assign = Object.assign || function (t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      for (var i in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    __createBinding = Object.create ? function (t, e, n, r) {
  void 0 === r && (r = n), Object.defineProperty(t, r, {
    enumerable: !0,
    get: function get() {
      return e[n];
    }
  });
} : function (t, e, n, r) {
  void 0 === r && (r = n), t[r] = e[n];
},
    __setModuleDefault = Object.create ? function (t, e) {
  Object.defineProperty(t, "default", {
    enumerable: !0,
    value: e
  });
} : function (t, e) {
  t.default = e;
},
    __importStar = function __importStar(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (null != t) for (var n in t) {
    "default" !== n && Object.hasOwnProperty.call(t, n) && __createBinding(e, t, n);
  }
  return __setModuleDefault(e, t), e;
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getTransformMatrix = exports.getTranslateXProperty = exports.getTouchmoveTranslatePosition = exports.getTranslate3dProperty = exports.getRenderStageItemStyles = exports.getRenderStageStyles = exports.getTransitionProperty = exports.getRenderWrapperStyles = exports.animate = exports.shouldHandleResizeEvent = exports.getElementFirstChild = exports.getElementCursor = exports.getAutoheightProperty = exports.getElementDimensions = exports.getItemWidth = exports.createDefaultTransformationSet = exports.createAutowidthTransformationSet = exports.isElement = exports.createClones = exports.getItemsOffset = exports.getItemsCount = exports.getSlides = void 0;

var Utils = __importStar(require("."));

function getElementDimensions(t) {
  if (t && t.getBoundingClientRect) {
    t = t.getBoundingClientRect();
    return {
      width: t.width,
      height: t.height
    };
  }

  return {
    width: 0,
    height: 0
  };
}

function shouldHandleResizeEvent(t, e, n) {
  return void 0 === e && (e = {}), void 0 === n && (n = {}), e.width !== n.width;
}

function animate(t, e) {
  var n = e || {},
      r = n.position,
      e = void 0 === r ? 0 : r,
      r = n.animationDuration,
      r = void 0 === r ? 0 : r,
      n = n.animationEasingFunction,
      n = void 0 === n ? "ease" : n;
  return exports.isElement(t) && (t.style.transition = "transform " + r + "ms " + n + " 0ms", t.style.transform = "translate3d(" + e + "px, 0, 0)"), t;
}

function getTranslateXProperty(t) {
  t = getTransformMatrix(t), t = t && t[4] || "";
  return Number(t);
}

function getTransformMatrix(t) {
  return Utils.isElement(t) && getComputedStyle(t).transform.match(/(-?[0-9.]+)/g) || [];
}

exports.getSlides = function (t) {
  var e = t.children,
      t = t.items,
      t = void 0 === t ? [] : t;
  return e ? e.length ? e : [e] : t;
}, exports.getItemsCount = function (t) {
  return exports.getSlides(t).length;
}, exports.getItemsOffset = function (t) {
  var e = t.infinite,
      n = t.paddingRight,
      t = t.paddingLeft;
  return e && (t || n) ? 1 : 0;
}, exports.createClones = function (t) {
  var e = exports.getSlides(t);
  if (!t.infinite) return e;
  var n = exports.getItemsCount(t),
      r = exports.getItemsOffset(t),
      i = Utils.getItemsInSlide(n, t),
      o = Math.min(i, n) + r,
      t = e.slice(0, o),
      o = e.slice(-o);
  return r && i === n && (i = e[0], n = e.slice(-1)[0], o.unshift(n), t.push(i)), o.concat(e, t);
}, exports.isElement = function (t) {
  try {
    return t instanceof Element || t instanceof HTMLDocument;
  } catch (t) {
    return !1;
  }
}, exports.createAutowidthTransformationSet = function (t) {
  return exports.isElement(t) ? Array.from(t.children || []).reduce(function (t, e, n) {
    var r = 0,
        i = n - 1,
        n = t[i],
        e = getElementDimensions(null == e ? void 0 : e.firstChild).width,
        e = void 0 === e ? 0 : e;
    return n && (r = 0 == i ? n.width : n.width + n.position), t.push({
      position: r,
      width: e
    }), t;
  }, []) : [];
}, exports.createDefaultTransformationSet = function (t, e, n) {
  var i = exports.getItemWidth(e, n);
  return t.reduce(function (t, e, n) {
    var r = 0,
        n = t[n - 1];
    return n && (r = i + n.position || 0), t.push({
      width: i,
      position: r
    }), t;
  }, []);
}, exports.getItemWidth = function (t, e) {
  return 0 < e ? t / e : t;
}, exports.getElementDimensions = getElementDimensions, exports.getAutoheightProperty = function (t, e, n) {
  e = exports.getElementCursor(e, n), n = exports.getElementFirstChild(t, e);

  if (exports.isElement(n)) {
    t = getComputedStyle(n), e = parseFloat(t.marginTop), t = parseFloat(t.marginBottom);
    return Math.ceil(n.offsetHeight + e + t);
  }
}, exports.getElementCursor = function (t, e) {
  var n = e.activeIndex,
      e = e.itemsInSlide;
  return t.infinite ? n + e + Utils.getItemsOffset(t) : n;
}, exports.getElementFirstChild = function (t, e) {
  t = t && t.children || [];
  return t[e] && t[e].firstChild || null;
}, exports.shouldHandleResizeEvent = shouldHandleResizeEvent, exports.animate = animate, exports.getRenderWrapperStyles = function (t, e, n) {
  var r = t || {},
      i = r.paddingLeft,
      o = r.paddingRight,
      s = r.animationDuration,
      e = r.autoHeight ? exports.getAutoheightProperty(n, t, e) : void 0;
  return {
    height: e,
    transition: e ? "height " + s + "ms" : void 0,
    paddingLeft: i + "px",
    paddingRight: o + "px"
  };
}, exports.getTransitionProperty = function (t) {
  var e = t || {},
      t = e.animationDuration,
      e = e.animationEasingFunction;
  return "transform " + (void 0 === t ? 0 : t) + "ms " + (void 0 === e ? "ease" : e) + " 0ms";
}, exports.getRenderStageStyles = function (t, e) {
  t = (t || {}).translate3d, t = "translate3d(" + -(void 0 === t ? 0 : t) + "px, 0, 0)";
  return _assign(_assign({}, e), {
    transform: t
  });
}, exports.getRenderStageItemStyles = function (t, e) {
  var n = e.transformationSet,
      r = e.fadeoutAnimationIndex,
      i = e.fadeoutAnimationPosition,
      o = e.fadeoutAnimationProcessing,
      e = e.animationDuration,
      n = (n[t] || {}).width;
  return o && r === t ? {
    transform: "translateX(" + i + "px)",
    animationDuration: e + "ms",
    width: n + "px"
  } : {
    width: n
  };
}, exports.getTranslate3dProperty = function (t, e) {
  var n = t,
      r = e.infinite,
      i = e.itemsOffset,
      o = void 0 === i ? 0 : i,
      i = e.itemsInSlide,
      i = void 0 === i ? 0 : i,
      e = e.transformationSet,
      e = void 0 === e ? [] : e;
  return r && (n = t + Utils.getShiftIndex(i, o)), (e[n] || {}).position || 0;
}, exports.getTouchmoveTranslatePosition = function (t, e) {
  return -(e - Math.floor(t));
}, exports.getTranslateXProperty = getTranslateXProperty, exports.getTransformMatrix = getTransformMatrix;